module.exports = __webpack_public_path__ + "img/Ministry_of_Aliyah_and Integration.e61bf662.svg";